import React from 'react';
import SparkOutputPreviewBoardListViewContainer from './SparkOutputPreviewBoardListViewContainer';
import { SparkScrollableGridContainer } from 'sharedComponents/UI';
import { useBoardNodesByBoardID } from 'hooks/Board';
import { useSparkBuilderStore } from 'stores';

function SparkOutputPreviewContainer() {
  const joinedSpark = useSparkBuilderStore(
    React.useCallback((state) => state.joinedSpark, [])
  );
  const { boardNodes } = useBoardNodesByBoardID(
    joinedSpark?.attributes.outputBoardID
  );
  return (
    <SparkScrollableGridContainer
      scrollableContainerStyle={{
        paddingX: 3,
        overflowY: 'auto',
        paddingBottom: '16px',
      }}
    >
      <SparkOutputPreviewBoardListViewContainer boardNodes={boardNodes} />
    </SparkScrollableGridContainer>
  );
}

export default SparkOutputPreviewContainer;
